import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveCommissions } from '../api/commissions';
import type { SaveCommissionsRequest } from '../types';
import { ApiError } from '../../../lib/api/error';
import { toast } from '../../../lib/toast';

export function useSaveCommissions(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SaveCommissionsRequest) => saveCommissions(payload),
    onSuccess: (count) => {
      toast.success(`${count} commission(s) saved successfully.`);
      void queryClient.invalidateQueries({ queryKey: ['commissions'] });
      onSuccess?.();
    },
    onError: (error) => {
      toast.error(ApiError.fromAxiosError(error).message);
    },
  });
}
